import { useEffect, useState } from 'react';

/** Для `width` + CSS transition: старт с 0, затем `targetPercent`. */
export function useAnimatedPercent(targetPercent: number) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(targetPercent);
  }, [targetPercent]);

  return value;
}
